/**
 * @flow
 * @author: Chinmaya
 */
import $ from 'jquery'

import { navigateTo } from 'gatsby-link'

// const spaceLeft = 70

export const scrollToSection = (section, spaceLeft = 70) => {
  $('html, body').animate(
    {
      scrollTop: $(`#${section}`).offset().top - spaceLeft
    },
    1000
  )
}

export const scrollToHome = () => {
  scrollToSection('headerSection')
}
export const scrollToiBC = () => {
  scrollToSection('ibCricketSection')
}

export const scrollToBusiness = () => {
  scrollToSection('businesses')
}
export const scrollToLearners = () => {
  scrollToSection('learners', 80)
}
export const scrollToGameDevelopers = () => {
  scrollToSection('game-developers')
}

export const scrollToOffices = () => {
  scrollToSection('our-offices')
}
const goToLocation = location => {
  window.location = location
}

export const goToHome = () => {
  navigateTo('/')
}
export const goToiBC = () => {
  goToLocation('/?id=launch')
}
export const goToBusiness = () => {
  goToLocation('/?id=businesses')
}
export const goToOffices = () => {
  goToLocation('/?id=our-offices')
}
export const goToLearners = () => {
  goToLocation('/?id=learners')
}
export const goToGameDevelopers = () => {
  goToLocation('/?id=game-developers')
}

export const goToOurServices = () => {
  goToLocation('/?id=our-services')
}

export const goToContactUs = () => {
  scrollToSection('contactUsSection')
}

export const scrollToContactUs = () => {
  scrollToSection('contactUsSection')
}

export function getQueryStringValue(name, url) {
  if (!url) url = window.location.href
  name = name.replace(/[\[\]]/g, '\\$&')
  let regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`),
    results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}
